import type { QueryKey } from "@tanstack/vue-query";

import { queryOptions } from "@tanstack/vue-query";

// A utility to create type-tagged query keys for typesafe usage
// e.g queryClient.getQueryData(...) or queryClient.setQueryData(...) will always be correctly inferred without explicit type annotations.
export function typedQueryOptions<TData>(queryKey: QueryKey) {
  return queryOptions({
    queryKey,
    queryFn: (): Promise<TData> => Promise.resolve(undefined as any as TData),
  } as const).queryKey;
}
